import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  Row,
  Card,
  Table,
  Container,
  Spinner,
} from "react-bootstrap";
import key1 from "../Images/key1.svg";
import key2 from "../Images/key2.svg";
import key3 from "../Images/key3.svg";
import key4 from "../Images/key4.svg";
import key5 from "../Images/key5.svg";
import key6 from "../Images/cardimg5.svg";
import core1 from "../Images/core1.png";
import core2 from "../Images/core2.png";
import core3 from "../Images/core3.png";
import core4 from "../Images/core4.png";
import core5 from "../Images/core5.png";
import core6 from "../Images/core6.png";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";
import { FaArrowAltCircleDown, FaArrowAltCircleRight } from "react-icons/fa";
import RootDomain from "..//Images/Root Domain.png";
import LinkingDomainImg from "../Images/Linking Domain.png";
import domainAuthority from "../Images/Domain Authority.png";
import LinkPropensity from "../Images/LinkPropensity.png";
import SpamScore from "../Images/SpamScore.png";
import pay from "../Images/pay.png";
import Footer from "./Footer";
import Nav from "./Navbar";
import SideTab from "./Toolstab";
import TestimonialPage from "./Testonomialraghar";
import { useNavigate } from "react-router-dom";
import { basicauth } from "../Utils/Credentials";
import { GlobalContext } from "../Context/GlobalState";
import { Helmet } from "react-helmet";
const Backlinkchecker = () => {
  const { password, username } = basicauth;
  const [visibleRows, setVisibleRows] = useState(10);
  const [transactionLoaderState, setTransactionLoaderState] = useState(false);
  const [linkingDomains, setLinkingDomains] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [selectedDomainType, setSelectedDomainType] = useState({
    value: "root",
    label: "Root Domain",
  });
  const base64Credentials = btoa(`${username}:${password}`);

  const FetchLinkingDomain = async () => {
    if (!domainInput) {
      alert("Please enter a valid domain.");
      return;
    }

    setTransactionLoaderState(true);

    try {
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/LinkBuilding/FetchBacklinks`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            url: domainInput,
          }),
        }
      );

      const data = await res.json();

      if (Array.isArray(data.results) && data.results.length > 0) {
        setTableData(data.results);
      } else {
        setTableData([]);
      }
    } catch (error) {
      console.error("Error fetching linking domain data:", error);
      setTableData([]);
    }

    setTransactionLoaderState(false);
  };

  const FetchLinkingDomainLinks = async (sourceUrl, sourceUrlId) => {
    console.log(sourceUrl);
    if (!domainInput) {
      alert("Please enter a valid domain.");
      return;
    }
    setTransactionLoaderState(true);
    try {
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/LinkBuilding/FetchLinkingDomainLinks`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            targetUrl: domainInput,
            sourceUrl: sourceUrl,
            sourceUrlId: sourceUrlId,
            type: "0",
          }),
        }
      );
      const result = await res.json();
      if (result.status === "0" && result.data) {
        setLinkingDomains(result.data);
      } else {
        console.error("Error fetching data:", result.msg);
      }
    } catch (error) {
      console.error("Error fetching linking domain data:", error);
    }
    setTransactionLoaderState(false);
  };

  const handleRowExpand = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };
  const generateUUID = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  };
  const [siteMetrics, setSiteMetrics] = useState(null);
  const FetchSiteMetrics = async (type) => {
    setTransactionLoaderState(true);
    try {
      const uuid = generateUUID();
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/CompetitiveResearch/FetchSiteMetrics`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uuid: uuid,
            url: domainInput,
            scope: "domain",
            type: type,
          }),
        }
      );
      const data = await res.json();
      if (
        data.status === "0" &&
        data.msg === "Success" &&
        data.data.length > 0
      ) {
        setSiteMetrics(data.data[0]);
      } else {
        console.log("No site metrics found.");
      }
    } catch (error) {
      console.error("Error fetching site metrics:", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };
  useEffect(() => {
    const styleSheet = document.styleSheets[0];

    const keyframes = `
 @keyframes fadeInUp {
 from {
 opacity: 0;
 transform: translateY(20px);
 }
 to {
 opacity: 1;
 transform: translateY(0);
 }
 }
 `;
    styleSheet.insertRule(keyframes, styleSheet.cssRules.length);
  }, []);
  const [domainInput, setDomainInput] = useState("");

  const handleInputChange = (e) => {
    setDomainInput(e.target.value);
  };
  const jsonLdData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Backlink Checker Tool | Analyze & Track SEO Links with SeoBix",
    url: "https://seobix.com/backlink-checker",
    description:
      "Check backlinks instantly with our best SEO tool. Analyze backlink quality, track links, and boost rankings now!",
    publisher: {
      "@type": "Organization",
      name: "Seobix",
      url: "https://seobix.com",
      logo: {
        "@type": "ImageObject",
        url: "https://seobix.com/Images/Backlinks.png",
      },
    },
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Backlink Checker",
          item: "https://seobix.com/backlink-checker",
        },
      ],
    },
    mainEntity: {
      "@type": "SoftwareApplication",
      name: "Backlink Checker Tool",
      applicationCategory: "SEO Tool",
      operatingSystem: "Web",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
        category: "Free SEO Tool",
      },
    },
    inLanguage: "en",
    keywords: [
      "best tool for checking backlinks",
      "check backlinks quality",
      "toxic backlinks checker",
      "backlinks checker bulk",
      "check my backlinks on google",
      "check spammy backlinks",
      "how to check for backlinks",
      "backlinks health check",
      "check for toxic backlinks",
      "check spam backlinks",
    ],
    mainEntityOfPage: [
      {
        "@type": "Question",
        name: "What is a Backlink Checker Tool?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "A Backlink Checker Tool helps you analyze backlinks to your website, check quality, detect toxic links, and monitor link health for SEO improvement.",
        },
      },
      {
        "@type": "Question",
        name: "Why should I check backlinks?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Checking backlinks ensures your website has high-quality links, avoids spammy or toxic backlinks, and boosts search engine rankings.",
        },
      },
      {
        "@type": "Question",
        name: "Can I check backlinks in bulk?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, SeoBix Backlink Checker allows bulk backlink analysis, saving time while monitoring multiple links efficiently.",
        },
      },
    ],
  };

  return (
    <>
      <style>
        {`
.table-wrapper {
 position: relative;
 min-height: 300px;
 overflow: hidden;
}
.view-more-overlay {
 position: sticky;
 bottom: 0;
 left: 0;
 right: 0;
 height: 60px;
 display: flex;
 justify-content: center;
 align-items: flex-end;
 z-index: 10;
 background: linear-gradient(to bottom, transparent, white);
}


 .blur-bg {
 position: absolute;
 bottom: 0;
 height: 60px;
 width: 100%;
 backdrop-filter: blur(6px);
 background: linear-gradient(to bottom, transparent, white);
 z-index: 1;
 pointer-events: none;
 }

 .view-more-btn {
 z-index: 2;
 pointer-events: auto;
 margin-bottom: 10px;
 }
`}
      </style>

      <Container fluid className="p-0" style={{ overflowX: "clip" }}>
        <Helmet>
          <title>
            Backlink Checker Tool | Analyze & Track SEO Links with SeoBix
          </title>
          <meta
            name="description"
            content="Check backlinks instantly with our best SEO tool. Analyze backlink quality, track links, and boost rankings now!"
          />
          <meta
            name="keywords"
            content="best tool for checking backlinks, check backlinks quality, toxic backlinks checker, backlinks checker bulk, check my backlinks on google, check spammy backlinks, how to check for backlinks, backlinks health check, check for toxic backlinks, check spam backlinks"
          />
          <link rel="canonical" href="https://seobix.com/backlink-checker" />

          <meta
            property="og:title"
            content="Backlink Checker Tool | Analyze & Track SEO Links with SeoBix"
          />
          <meta
            property="og:description"
            content="Check backlinks instantly with our best SEO tool. Analyze backlink quality, track links, and boost rankings now!"
          />
          <meta
            property="og:url"
            content="https://seobix.com/backlink-checker"
          />
          <meta property="og:site_name" content="Seobix" />
          <meta property="og:type" content="website" />
          <meta
            property="og:image"
            content="https://seobix.com/Images/Backlinks.png"
          />
          <meta property="og:image:width" content="600" />
          <meta property="og:image:height" content="600" />
          <meta property="og:locale" content="en_US" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content="Backlink Checker Tool | Analyze & Track SEO Links with SeoBix"
          />
          <meta
            name="twitter:description"
            content="Check backlinks instantly with our best SEO tool. Analyze backlink quality, track links, and boost rankings now!"
          />
          <meta
            name="twitter:image"
            content="https://seobix.com/Images/Backlinks.png"
          />
          <meta name="twitter:site" content="@seobix" />
          <meta name="twitter:creator" content="@seobix" />

          <script type="application/ld+json">
            {JSON.stringify(jsonLdData)}
          </script>
        </Helmet>
        <div>
          <Nav />
        </div>
        <Row
          className="d-flex justify-content-center "
          style={{
            background:
              "linear-gradient(to right, #AFDDFF 0%, #C5E7FF 30%, #DAF0FF 60%, #EDF8FF 85%, #FFFFFF 100%)",
          }}
        >
          <Col
            md={10}
            className="mt-4"
            style={{
              borderRadius: "1rem",
            }}
          >
            {transactionLoaderState && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  height: "100vh",
                  width: "100vw",
                  background: "rgba(255,255,255,0.6)",
                  zIndex: 9999,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            )}

            <div className="m-3">
              <style>
                {`
 .hide-scrollbar::-webkit-scrollbar {
 display: none; }
 `}
              </style>

              <h1
                style={{
                  fontSize: "4.5rem",
                  fontWeight: "500",
                  color: "#090040",
                }}
              >
                Backlink Checker
              </h1>
              <p
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "400",
                  color: "#090040",
                }}
              >
                Test SEOBIX Backlink Checker free. Get a glimpse
                <br />
                into the strength of our top-notch equipment.
              </p>

              <Form className="mb-4">
                <Row className="g-2 ">
                  <Col md={7}>
                    <Form.Group controlId="formDomainInput">
                      <Form.Label className="visually-hidden">
                        Domain
                      </Form.Label>
                      <Form.Control
                        value={domainInput}
                        onChange={handleInputChange}
                        type="text"
                        placeholder="Enter domain (e.g. seobix.com)"
                        style={{
                          // background: "transparent",
                          color: "#090040",
                          // border: "1px solid #090040",
                          borderRadius: "0",
                          fontSize: "1.2rem",
                          fontWeight: "400",
                          height: "48px",
                          // color: "#000",
                        }}
                        className="shadow-sm px-4"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group controlId="formDomainType">
                      <Form.Label className="visually-hidden">
                        Domain Type
                      </Form.Label>
                      <Form.Select
                        value={selectedDomainType.value}
                        onChange={(e) =>
                          setSelectedDomainType({
                            value: e.target.value,
                            label:
                              e.target.value === "root"
                                ? "🌐 Root Domain"
                                : "🔗 Sub Domain",
                          })
                        }
                        style={{
                          background: "",
                          // color: "#fff",
                          border: "1px solid #cbd5e1",
                          borderRadius: 0,
                          fontSize: "1.2rem",
                          fontWeight: "bold",
                          height: "48px",
                        }}
                      >
                        <option value="root">🌐 Root Domain</option>
                        <option value="sub">🔗 Sub Domain</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={2}>
                    <Button
                      className="w-100"
                      style={{
                        background: "#F80",
                        color: "#fff",
                        border: "none",
                        fontWeight: "bold",
                        fontSize: "1.2rem",
                        borderRadius: 0,
                        height: "48px",
                      }}
                      onClick={() => {
                        FetchLinkingDomain("1");
                        FetchSiteMetrics("1");
                      }}
                    >
                      Analyze
                    </Button>
                  </Col>
                </Row>
              </Form>

              {siteMetrics && (
                <div
                  className="mb-2 p-2"
                  style={{
                    background: "rgba(234,229,244)",
                    borderRadius: ".4rem",
                  }}
                >
                  <h5 className="text-center" style={{ color: "#441752" }}>
                    Result for {siteMetrics.url}
                  </h5>
                  <Row>
                    <Col md={3}>
                      <Card
                        className="p-1"
                        style={{ background: "#fff", borderRadius: "0.4rem" }}
                      >
                        <h6 className="text-center">
                          <b>Domain Authority</b>
                        </h6>
                        <div className="d-flex align-items-center justify-content-center">
                          <CustomPieChart
                            value={Number(siteMetrics.da)}
                            fillColor="#c96117ff"
                          />
                        </div>
                      </Card>
                    </Col>
                    <Col md={3}>
                      <Card
                        className="p-1"
                        style={{ background: "#fff", borderRadius: "0.4rem" }}
                      >
                        <h6 className="text-center">
                          <b>Page Authority</b>
                        </h6>
                        <div className="d-flex align-items-center justify-content-center">
                          <CustomPieChart
                            value={Number(siteMetrics.pa)}
                            fillColor="#003366"
                          />
                        </div>
                      </Card>
                    </Col>
                    <Col md={3}>
                      <Card
                        className="p-1"
                        style={{ background: "#fff", borderRadius: "0.4rem" }}
                      >
                        <h6 className="text-center">
                          <b>Linking Domains</b>
                        </h6>
                        <div className="d-flex align-items-center justify-content-center">
                          <CustomPieChart
                            value={Number(siteMetrics.linking_domain)}
                            fillColor="#ffc107"
                          />
                        </div>
                      </Card>
                    </Col>
                    <Col md={3}>
                      <Card
                        className="p-1"
                        style={{ background: "#fff", borderRadius: "0.4rem" }}
                      >
                        <h6 className="text-center">
                          <b>Spam Score</b>
                        </h6>
                        <div className="d-flex align-items-center justify-content-center">
                          <CustomPieChart
                            value={Number(siteMetrics.spam_score)}
                            fillColor="#ff0055"
                          />
                        </div>
                      </Card>
                    </Col>
                  </Row>
                </div>
              )}
              {tableData.length > 0 && (
                <div className="table-wrapper position-relative">
                  <Table className="mt-4" responsive bordered>
                    <thead>
                      <tr>
                        <th>Root Domain</th>
                        <th>Linking Domains</th>
                        <th>Domain Authority</th>
                        <th>Link Propensity</th>
                        <th>Spam Score</th>
                        <th>Pages</th>
                        <th>Nofollow</th>
                        <th>Redirect</th>
                        <th>Deleted</th>
                        <th className="text-center">Expand</th>
                      </tr>
                    </thead>

                    <tbody>
                      {tableData.length > 0 ? (
                        tableData.slice(0, visibleRows).map((item, index) => (
                          <React.Fragment key={index}>
                            <tr>
                              <td>{item.root_domain}</td>
                              <td>{item.root_domains_to_root_domain}</td>
                              <td>{item.domain_authority}</td>
                              <td>
                                {parseFloat(item.link_propensity).toFixed(2)}
                              </td>
                              <td>
                                {item.spam_score >= 0
                                  ? `${item.spam_score}%`
                                  : "N/A"}
                              </td>
                              <td>{item.to_target?.pages ?? 0}</td>
                              <td>{item.to_target?.nofollow_pages ?? 0}</td>
                              <td>{item.to_target?.redirect_pages ?? 0}</td>
                              <td>{item.to_target?.deleted_pages ?? 0}</td>

                              <td className="text-center">
                                {expandedRow === index ? (
                                  <FaArrowAltCircleDown
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleRowExpand(index)}
                                  />
                                ) : (
                                  <FaArrowAltCircleRight
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      handleRowExpand(index);
                                      if (item?.root_domain) {
                                        FetchLinkingDomainLinks(
                                          item.root_domain,
                                          index
                                        );
                                      }
                                    }}
                                  />
                                )}
                              </td>
                            </tr>

                            {expandedRow === index && (
                              <tr>
                                <td colSpan="10">
                                  <Table responsive bordered>
                                    <thead>
                                      <tr>
                                        <th>URL</th>
                                        <th>Domain Authority (DA)</th>
                                        <th>Page Authority (PA)</th>
                                        <th>Spam Score</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {linkingDomains.length > 0 ? (
                                        linkingDomains.map((item, index) => (
                                          <tr key={index}>
                                            <td>
                                              <a
                                                href={`https://${item.url}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                              >
                                                {item.url}
                                              </a>
                                            </td>

                                            <td style={{ width: 100 }}>
                                              <CustomPieChart
                                                value={Number(item.da)}
                                                fillColor="#007bff"
                                              />
                                            </td>

                                            <td style={{ width: 100 }}>
                                              <CustomPieChart
                                                value={Number(item.pa)}
                                                fillColor="#28a745"
                                              />
                                            </td>

                                            <td style={{ width: 100 }}>
                                              <CustomPieChart
                                                value={Number(item.spamScore)}
                                                fillColor="#dc3545"
                                              />
                                            </td>
                                          </tr>
                                        ))
                                      ) : (
                                        <tr>
                                          <td
                                            colSpan="5"
                                            className="text-center"
                                          >
                                            No data available
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </Table>
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  {visibleRows < tableData.length && (
                    <div className="text-center mt-3">
                      <Button
                        variant="primary"
                        onClick={() => {
                          window.location.href =
                            "https://dashboard.seobix.com/Register";
                        }}
                      >
                        View More
                      </Button>
                    </div>
                  )}
                </div>
              )}
              <div
                style={{
                  // background: "#2E3C56",
                  margin: "2rem 0",
                  padding: "2rem 1rem",
                  color: "#fff",
                  borderTop: "1px solid #495670",
                  borderBottom: "1px solid #495670",
                }}
              >
                <Row>
                  <Col md={6}>
                    <h3
                      style={{
                        fontWeight: "600",
                        marginBottom: "1rem",
                        color: "#090040",
                        fontSize: "2.5rem",
                      }}
                    >
                      The best backlink checker
                    </h3>

                    <p style={{ fontSize: "1.2rem", color: "#090040" }}>
                      Backlinks Checker by SeoBix&nbsp;
                      <span style={{ color: "#B12C00", fontWeight: "400" }}>
                        tracks and monitors&nbsp;
                      </span>
                      all your backlinks, provides you with accurate
                      information, to help you grow faster.
                    </p>

                    <p
                      className="mb-4"
                      style={{ fontSize: "1.5rem", color: "#090040" }}
                    >
                      Begin SEO with SeoBix!
                    </p>

                    <div className="d-flex align-items-center gap-3 flex-wrap">
                      <a
                        href="/register"
                        className="start-now-btn"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        Sign Up with 3 month free trial
                      </a>
                      <span
                        style={{
                          color: "#F80",
                          fontWeight: "700",
                          whiteSpace: "nowrap",
                        }}
                      >
                        OR
                      </span>
                      <a
                        href="/register"
                        className="start-now-btn"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        Explore More Tools
                      </a>
                    </div>
                  </Col>

                  <Col md={6}>
                    <Row>
                      <Col xs={6} className="text-center mb-4">
                        <div
                          style={{
                            fontSize: "4rem",
                            fontWeight: "600",
                            color: "#090040",
                          }}
                        >
                          1M+
                        </div>
                        <div style={{ fontSize: "1.2rem", color: "#090040" }}>
                          Pages in index
                        </div>
                      </Col>

                      <Col xs={6} className="text-center mb-4">
                        <div
                          style={{
                            fontSize: "4rem",
                            fontWeight: "600",
                            color: "#090040",
                          }}
                        >
                          60K+
                        </div>
                        <div style={{ fontSize: "1.2rem", color: "#090040" }}>
                          Internal backlinks
                        </div>
                      </Col>

                      <Col xs={6} className="text-center">
                        <div
                          style={{
                            fontSize: "4rem",
                            fontWeight: "600",
                            color: "#090040",
                          }}
                        >
                          100+
                        </div>
                        <div style={{ fontSize: "1.2rem", color: "#090040" }}>
                          Domains
                        </div>
                      </Col>

                      <Col xs={6} className="text-center">
                        <div
                          style={{
                            fontSize: "4rem",
                            fontWeight: "600",
                            color: "#090040",
                          }}
                        >
                          200K+
                        </div>
                        <div style={{ fontSize: "1.2rem", color: "#090040" }}>
                          External backlinks
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center mt-3" style={{ margin: "0" }}>
          <Col md={10}>
            <Row className="justify-content-between">
              <Content />
              <Col md={3}>
                <div
                  className="mb-5"
                  style={{
                    position: "sticky",
                    top: "20px",
                    zIndex: 10,
                    background: "#f8f9fa",
                    padding: "1rem",
                    borderRadius: "10px",
                  }}
                >
                  <h5
                    className="text-center mb-4"
                    style={{
                      fontWeight: "bold",
                      fontSize: "1.3rem",
                      color: "#fff",
                      backgroundColor: "#799EFF",
                      display: "inline-block",
                      padding: "6px 16px",
                      borderRadius: "0.5rem",
                    }}
                  >
                    🚀 Explore More SEO Tools
                  </h5>
                  <SideTab />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <div
          className="m-0 p-0"
          style={{
            overflow: "hidden",
            background:
              "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",

            borderTopRightRadius: "2rem",
            borderTopLeftRadius: "2rem",
          }}
        >
          <Footer />
        </div>
      </Container>
    </>
  );
};
const CustomPieChart = ({ value, fillColor = "#441752" }) => {
  const radius = 36;
  const strokeWidth = 8;
  const normalizedRadius = radius - strokeWidth * 0.5;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (value / 100) * circumference;

  return (
    <svg height={radius * 2} width={radius * 2}>
      <circle
        stroke="#ddd"
        fill="transparent"
        strokeWidth={strokeWidth}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
      <circle
        stroke={fillColor}
        fill="transparent"
        strokeWidth={strokeWidth}
        strokeDasharray={circumference + " " + circumference}
        style={{ strokeDashoffset, transition: "stroke-dashoffset 0.35s" }}
        strokeLinecap="round"
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
      <text
        x="50%"
        y="50%"
        dominantBaseline="middle"
        textAnchor="middle"
        fill={fillColor}
        fontSize="12"
        fontWeight="bold"
      >
        {value}
      </text>
    </svg>
  );
};
const Content = () => {
  const [showMore, setShowMore] = useState(false);

  return (
    <>
      <Col md={8}>
        <h3>Why Are Backlinks Important?</h3>
        <p style={{ fontSize: "1.1rem", fontWeight: "600" }}>
          1. Improves SEO Rankings
        </p>
        <p>
          The presence of the backlinks is a type of recommendation by the other
          websites that tells the search engines that your content is valuable
          and reputable. The quality of the backlinks you have, especially those
          of the domains of authorities, the higher the likelihood of appearing
          on the first page of Google. Back links are one of the ranking factors
          in search engine algorithms and therefore very important in the
          success of SEO.
        </p>
        <p style={{ fontSize: "1.1rem", fontWeight: "600" }}>
          2. Increases Website Traffic
        </p>
        <p>
          A back link on a high-relevant or active site can lead to a direct
          targeted traffic to your site. When they visit your content whenever
          they are making a selection of those links, you are quite likely to
          convert. This referral traffic is typically highly active due to the
          fact that it is of users who are already interested in similar topics.
        </p>
        <p style={{ fontSize: "1.1rem", fontWeight: "600" }}>
          3. Creates Authority and credibility
        </p>

        <div style={{ position: "relative" }}>
          <p
            style={{
              maxHeight: showMore ? "none" : "4.2rem",
              overflow: "hidden",
              textOverflow: "ellipsis",
              WebkitLineClamp: 2,
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              filter: showMore ? "none" : "blur(2px)",
              transition: "all 0.3s ease",
              marginBottom: showMore ? "1rem" : "2.5rem",
            }}
          >
            The scores obtained by links to trustworthy sites gives credibility
            to your brand both to the search engines and to the users
            themselves. It shows that your content has been so appreciated by
            other trusted websites to refer to it. This will help in the long
            run to boost the authority of your domain and to become a thought
            leader in your niche.
          </p>

          {!showMore && (
            <div
              style={{
                position: "absolute",
                bottom: "0.5rem",
                left: 0,
                right: 0,
                height: "2.5em",
                background:
                  "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.8) 100%)",
              }}
            />
          )}
        </div>

        <div className="d-flex justify-content-center">
          {!showMore && (
            <Button
              onClick={() => setShowMore(true)}
              style={{
                padding: "6px 20px",
                backgroundColor: "#fff",
                color: "#0d6efd",
                fontWeight: "600",
                fontSize: "0.95rem",
                border: "2px solid #0d6efd",
                borderRadius: "999px",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#0d6efd";
                e.target.style.color = "#fff";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#fff";
                e.target.style.color = "#0d6efd";
              }}
            >
              Read More
            </Button>
          )}
        </div>

        {showMore && (
          <>
            <p style={{ fontSize: "1.1rem", fontWeight: "600" }}>
              4. Faster Indexing of Search Engines
            </p>
            <p>
              The web is searched and crawled using bots of search engines.
              'Backlinks to your site by already indexed and frequently crawled
              websites improves the likelihood of your content being located and
              indexed faster. It is especially helpful with new web pages or new
              websites which were just published.
            </p>
            <p style={{ fontSize: "1.1rem", fontWeight: "600" }}>
              5. Enhances Brand Awareness
            </p>
            <p>
              The websites, blogs or news sources related to the industry can
              help in placing your brand to the right audience with the help of
              backlinks. Each back link is an entrance, where a new user can get
              to know your brand, products or services. Such exposure will
              ultimately work to your benefit of establishing your brand and
              strength in your market.
            </p>
            <p style={{ fontSize: "1.2rem", fontWeight: "600" }}>
              The Root Domains, Spam Score, and more : Decode Your Backlink
              Profile Now
            </p>
            <p style={{ fontSize: "1.1rem", fontWeight: "600" }}>
              1. Root Domain
            </p>
            <img
              className="mb-2"
              src={RootDomain}
              alt="Root Domain"
              style={{ width: "50vw" }}
            />
            <p>
              Root domain- This is the lowest level domain name of a website
              like example.com, without prefixes like, www, or subdomain like,
              blog.example.com. Back links across root domains are regarded as
              more valuable in SEO as compared to a number of links in one
              domain. The reason is that every distinct root domain is a vote by
              itself of confidence. Search engines put more emphasis on
              backlinks of various root domains in order to determine the
              authority of your site.
            </p>
            <p style={{ fontSize: "1.1rem", fontWeight: "600" }}>
              2. Linking Domain
            </p>
            <img
              className="mb-2"
              src={LinkingDomainImg}
              alt="Linking Domain"
              style={{ width: "50vw" }}
            />
            <p>
              Any third-party site with no less than one backlink to your site
              can be considered a linking domain. Although the same domain may
              have a number of pages linked with it, it is still considered one
              linking domain. Linking domain referral is another important
              parameter that determines the diversity and credibility of
              backlinks of your site. The more the connection points of
              legitimate websites the higher the ranking of the search engines.
            </p>
            <p style={{ fontSize: "1.1rem", fontWeight: "600" }}>
              3. Domain Authority
            </p>
            <img
              className="mb-2"
              src={domainAuthority}
              alt="Linking Domain"
              style={{ width: "50vw" }}
            />
            <p>
              Link propensity is the number of times that a given website
              outlinks to other domains. Websites that have high link propensity
              have a lot of outbound links (such as blogs or directories),
              whereas websites with low link propensity (such as news websites
              or educational institutions) have very few. A backlink that comes
              with a low link propensity site is likely to be more useful
              because the implication will be that the link was earned by high
              quality trusted content.
            </p>
            <p style={{ fontSize: "1.1rem", fontWeight: "600" }}>
              4. Link Propensity
            </p>
            <img
              className="mb-2"
              src={LinkPropensity}
              alt="Linking Domain"
              style={{ width: "50vw" }}
            />
            <p>
              The propensity of the links is called the frequency of the links a
              website has with other domains. High link propensity websites tend
              to contain numerous outbound links (such as blogs or directories)
              whereas low link propensity websites (such as news sites or
              learning institutions) generally contain few outbound links. A
              backlink of a low link propensity site can be more valuable
              because it indicates that the link was obtained due to quality
              trusted content.
            </p>
            <p style={{ fontSize: "1.1rem", fontWeight: "600" }}>
              5. Spam Score
            </p>
            <img
              className="mb-2"
              src={SpamScore}
              alt="Linking Domain"
              style={{ width: "50vw" }}
            />
            <p>
              Spam Score is a parameter that was created to predict the
              possibility of a domain being considered as spam by search
              engines. It is normally represented as a percentage increase in a
              more significant value is a higher risk. Using multiple red flags
              such as poor content, stuffing with keywords, too much
              advertisement or links to bad neighborhoods, this score is
              determined. It is a good idea to have back links with high spam
              scores websites that need to be cleaned or disavowed.
            </p>{" "}
            <div className="d-flex justify-content-center mt-4">
              <Button
                onClick={() => setShowMore(false)}
                style={{
                  padding: "6px 20px",
                  backgroundColor: "#fff",
                  color: "#dc3545",
                  fontWeight: "600",
                  fontSize: "0.95rem",
                  border: "2px solid #dc3545",
                  borderRadius: "999px",
                  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#dc3545";
                  e.target.style.color = "#fff";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#fff";
                  e.target.style.color = "#dc3545";
                }}
              >
                Hide
              </Button>
            </div>
          </>
        )}
        <Plancard />
        <Trialcards />
        <Related />
        <TestimonialPage />
        <Specialoffer />
        <BackLinkCards />
        <Plancard />
      </Col>
    </>
  );
};
const Plancard = () => {
  const [isYearly, setIsYearly] = useState(false);
  const plans = [
    {
      title: "Free",
      monthly: "$0",
      yearly: "$0",
      Free: "3 Month Free Trial",
      features: ["Limited Access"],
      buttonText: "Buy Plan",
      color: "#e0f2fe",
      border: "#38bdf8",
      image: pay,
    },
    {
      title: "Basic",
      monthly: "$150/mo",
      features: ["5 Projects", "Standard Reports", "Email Support"],
      buttonText: "Buy Plan",
      color: "#e7f5ff",
      border: "#339af0",
      image: pay,
    },
    {
      title: "Standard",
      monthly: "$350/mo",
      features: ["10 Projects", "Advanced Reports", "Priority Support"],
      buttonText: "Buy Plan",
      color: "#e6fcf5",
      border: "#20c997",
      image: pay,
    },
    {
      title: "Premium",
      monthly: "$750/mo",
      features: ["Unlimited Projects", "All Features", "24/7 Support"],
      buttonText: "Buy Plan",
      color: "#fff3bf",
      border: "#fcc419",
      image: pay,
    },
  ];

  return (
    <Container className="my-5">
      <div className="text-center mb-4">
        <h2 style={{ fontWeight: "700", fontSize: "2rem" }}>
          Boost Your SEO With Our Amazing Plans
        </h2>
        <h4 className="font-weight-bold mb-4" style={{ color: "#441752" }}>
          🚀 Improve Your Rankings —{" "}
          <span style={{ color: "#FC4100" }}>
            Try Our Service Free for 3 Months!
          </span>
        </h4>
        <p style={{ color: "#6b7280" }}>
          Flexible pricing plans designed for every stage of your journey
        </p>
        <div className="d-flex justify-content-center mt-4">
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontWeight: "500" }}>Monthly</span>

            <div
              className="m-2"
              style={{ transform: "scale(1.5)", transformOrigin: "center" }}
            >
              <Form.Check
                type="switch"
                id="custom-switch"
                checked={isYearly}
                onChange={() => setIsYearly(!isYearly)}
              />
            </div>

            <div className="d-flex align-items-center gap-2">
              <span style={{ fontWeight: "500" }}>Yearly</span>

              <div
                className="start-now-btn mx-3"
                style={{
                  backgroundColor: "#e6f4ea",
                  color: "#2f855a",
                  padding: "6px 12px",
                  borderRadius: "8px solid",
                  fontWeight: "600",
                  fontSize: "0.9rem",
                  border: "1px solid #20c997",
                }}
              >
                🎉{" "}
                <span style={{ color: "#0B1D51" }}>
                  Get{" "}
                  <span style={{ color: "#0B1D51" }}>
                    <b>30% OFF</b>
                  </span>{" "}
                  on Yearly Plans
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Row className="g-4 justify-content-center">
        {plans.map((plan, idx) => (
          <Col md={6} lg={3} key={idx}>
            <div style={{ position: "relative" }}>
              {plan.title === "Free" && (
                <div
                  style={{
                    position: "absolute",
                    top: "-12px",
                    left: 0,
                    right: 0,
                    height: "32px",
                    backgroundColor: "#38bdf8",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    borderTopLeftRadius: "16px",
                    borderTopRightRadius: "16px",
                    zIndex: 2,
                  }}
                >
                  {plan.Free}
                </div>
              )}

              <Card
                className="p-2"
                style={{
                  backgroundColor: plan.color,
                  border: `2px solid ${plan.border}`,
                  borderRadius: "16px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow:
                    plan.title === "Free"
                      ? "0 12px 28px rgba(56, 189, 248, 0.5)"
                      : "0 4px 12px rgba(0,0,0,0.05)",
                  marginTop: plan.title === "Free" ? "16px" : "0",
                }}
              >
                <Card.Body>
                  <Card.Title style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                    {plan.title}
                  </Card.Title>
                  <h3 style={{ fontWeight: "bold", margin: "1rem 0" }}>
                    {isYearly
                      ? plan.title === "Free"
                        ? plan.yearly
                        : (() => {
                            const monthlyPrice = parseFloat(
                              plan.monthly.replace(/[^0-9.]/g, "")
                            );
                            const yearlyRaw = monthlyPrice * 12;
                            const discounted = yearlyRaw * 0.7;
                            return `$${Math.round(discounted)}/yr`;
                          })()
                      : plan.monthly}
                  </h3>
                  <a
                    href="/register"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      backgroundColor: plan.border,
                      color: "white",
                      textDecoration: "none",
                      borderRadius: "999px",
                      padding: "8px 20px",
                      fontWeight: "600",
                      marginTop: "1rem",
                    }}
                  >
                    {plan.buttonText}
                  </a>

                  <div className="mt-3">
                    <img
                      src={plan.image}
                      alt={plan.title}
                      style={{
                        // width: "15vw",
                        objectFit: "contain",
                        marginBottom: "1rem",
                      }}
                    />
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};
const Trialcards = () => {
  const cardsData = [
    {
      keyImg: key1,
      coreImg: core5,
      title: "Integrated Search Console, Google Trends and Google Analytics",
      desc: "Smarter SEO insights in one place and see what’s popular in different countries and other website matrics. Seobix makes it easy and effective.",
    },
    {
      keyImg: key2,
      coreImg: core4,
      title: "Search Engine Optimization",
      desc: "SEO gets easier with SeoBix whether you just start your website or growing your online presence. Our all-in-one SEO tool helps you fix issues and improve online visibility.",
    },
    {
      keyImg: key3,
      coreImg: core2,
      title: "Social Media Optimization",
      desc: "You can monitor and post from all your favorite platforms, YouTube, Facebook, LinkedIn, and Instagram, all from under one roof.",
    },
    {
      keyImg: key4,
      coreImg: core1,
      title: "Competitive Research Overview",
      desc: "You can check domain overview and website age and how their pages look on Google with our SERP Simulator. Seobix gives you the insights you need to compete smarter, not harder.",
    },
    {
      keyImg: key5,
      coreImg: core3,
      title: "Structure Data",
      desc: "With the right setup, At Seobix, we make it super easy to add and check structured data, so your site gets noticed for all the right reasons.",
    },
    {
      keyImg: key6,
      coreImg: core6,
      title: "Keyword Research",
      desc: "Our Bix keyword Research helps you discover high-potential keywords your audience is actually searching for.",
    },
  ];
  return (
    <div className="mt-md-5 mt-3 m-md-0 m-2 ">
      <h2
        className="text-center m-4"
        style={{ fontWeight: "700", fontSize: "2rem" }}
      >
        What Includes In All Plans ?
      </h2>
      <div className="row m-0 p-0">
        {cardsData.map((card, index) => (
          <div key={index} className="col-12 col-md-4 p-2 d-flex">
            <div className="card w-100 h-100 p-2">
              <div className="d-flex h-100">
                <div
                  style={{ flex: 1 }}
                  className="d-flex flex-column position-relative"
                >
                  <div>
                    <img
                      src={card.keyImg}
                      alt={card.title}
                      style={{
                        height: "5vh",
                        objectFit: "contain",
                        marginBottom: "0.5rem",
                      }}
                    />
                    <h5>{card.title}</h5>
                  </div>
                </div>

                <div
                  style={{ flex: 1 }}
                  className="d-flex align-items-center justify-content-center"
                >
                  <img
                    src={card.coreImg}
                    alt={card.title}
                    className="img-fluid"
                    style={{ maxHeight: "200px", objectFit: "contain" }}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
const Specialoffer = () => {
  return (
    <div
      className="start-now-btn p-2"
      style={{
        background: "#799EFF",
        borderRadius: "24px",
        color: "white",
        textAlign: "center",
        margin: "3rem auto",
        width: "90%",
        maxWidth: "1000px",
        position: "relative",
      }}
    >
      <h2 className="mb-3" style={{ fontSize: "2rem", fontWeight: "bold" }}>
        Let’s do this! Start unlocking powerful backlink insights.
      </h2>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        <a
          // href="/register"
          onClick={() => window.open("https://dashboard.seobix.com/", "_blank")}
          style={{
            backgroundColor: "#fff",
            color: "#000",
            padding: "12px 24px",
            borderRadius: "12px",
            fontWeight: "600",
            textDecoration: "none",
            minWidth: "150px",
            textAlign: "center",
          }}
        >
          Start 3 Months Free Trial
        </a>
      </div>

      <p style={{ color: "#fff", marginTop: "20px", fontSize: "14px" }}>
        <b> Full access — No Credit card Needed.</b>
      </p>
    </div>
  );
};
const Related = () => {
  const { siteurl, siteid } = useContext(GlobalContext);
  const { password, username } = basicauth;
  const base64Credentials = btoa(`${username}:${password}`);
  const domainTypeOptions = [
    { value: "domain", label: "Domain" },
    { value: "subdomain", label: "Subdomain" },
  ];

  const regionOptions = [
    { value: "en-US", label: "United States (en-US)" },
    { value: "en-GB", label: "United Kingdom (en-GB)" },
    { value: "en-CA", label: "Canada (English) (en-CA)" },
    { value: "en-AU", label: "Australia (en-AU)" },
  ];

  const [formData, setFormData] = useState({
    domainInput: siteurl,
    domainType: domainTypeOptions[0],
    region: regionOptions[0],
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const [rankingKeywords, setRankingKeywords] = useState([]);
  const [queary, setqueary] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [showResults, setShowResults] = useState(false);

  const generateUUID = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  };

  const DomainRankingKeywords = async (type) => {
    try {
      const uuid = generateUUID();
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/CompetitiveResearch/DomainRankingKeywords`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uuid: uuid,
            url: formData.domainInput,
            scope: formData.domainType?.value,
            locale: formData.region?.value,
            type: type,
          }),
        }
      );
      const data = await res.json();

      if (data.status === "0" && data.data) {
        const rankingData = data.data.map((item) => ({
          keyword: item.keyword,
          url: item.url,
          ranking_page: item.ranking_page,
          rank_position: item.rank_position,
          difficulty: item.difficulty,
          volume: item.volume,
        }));

        setRankingKeywords(rankingData);
        setqueary({ query: data.data[0].url });
        processChartData(rankingData);
        setShowResults(true);
      } else {
        setShowResults(false);
      }
    } catch (error) {
      console.log("error", error);
      setShowResults(false);
    }
  };

  const processChartData = (keywords) => {
    const ranges = {
      "1-3": 0,
      "4-10": 0,
      "11-20": 0,
      "21-30": 0,
      "31-40": 0,
      "41-50": 0,
    };
    keywords.forEach((keyword) => {
      const position = keyword.rank_position;
      if (position >= 1 && position <= 3) ranges["1-3"]++;
      else if (position >= 4 && position <= 10) ranges["4-10"]++;
      else if (position >= 11 && position <= 20) ranges["11-20"]++;
      else if (position >= 21 && position <= 30) ranges["21-30"]++;
      else if (position >= 31 && position <= 40) ranges["31-40"]++;
      else if (position >= 41 && position <= 50) ranges["41-50"]++;
    });

    setChartData([
      { range: "#1-3", count: ranges["1-3"] },
      { range: "#4-10", count: ranges["4-10"] },
      { range: "#11-20", count: ranges["11-20"] },
      { range: "#21-30", count: ranges["21-30"] },
      { range: "#31-40", count: ranges["31-40"] },
      { range: "#41-50", count: ranges["41-50"] },
    ]);
  };

  const countKeywordsInRankRange = (keywords, start, end) => {
    return keywords.filter(
      (keyword) =>
        keyword.rank_position >= start && keyword.rank_position <= end
    ).length;
  };

  const range1to3 = countKeywordsInRankRange(rankingKeywords, 1, 3);
  const range4to10 = countKeywordsInRankRange(rankingKeywords, 4, 10);
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/bix-keyword-analyzer");
  };
  const [hasLoaded, setHasLoaded] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setHasLoaded(true);
    }, 500);
  }, []);

  return (
    <div className="mt-5 mb-5">
      <div
        // onClick={handleClick}
        style={{
          cursor: "pointer",
        }}
      >
        <Row
          className="justify-content-center"
          style={{
            margin: "0",
            background: "linear-gradient(to right, #EDE7F6, #E3F2FD)",
            borderRadius: "12px",
            transition: "transform 0.2s ease",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.01)")
          }
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          <Col md={10} className="p-3">
            <h3 className="text-center">
              <b>Find Your Domain's Ranking Keywords Instantly</b>
            </h3>
            <p className="text-center">
              See which keywords your website currently ranks for in search
              engines. Analyze performance, uncover SEO opportunities, and boost
              your visibility.
            </p>

            <Row className=" align-items-center rounded m-3">
              <Col md={6}>
                <Form.Control
                  type="text"
                  placeholder="Enter a domain, subdomain, or exact page"
                  value={formData.domainInput}
                  onChange={(e) => handleChange("domainInput", e.target.value)}
                />
              </Col>

              <Col md={4} className="d-flex align-items-center p-0">
                <Form.Select
                  className="mx-2"
                  value={formData.domainType.value}
                  onChange={(e) =>
                    handleChange(
                      "domainType",
                      domainTypeOptions.find(
                        (opt) => opt.value === e.target.value
                      )
                    )
                  }
                >
                  {domainTypeOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>

                <Form.Select
                  value={formData.region.value}
                  onChange={(e) =>
                    handleChange(
                      "region",
                      regionOptions.find((opt) => opt.value === e.target.value)
                    )
                  }
                >
                  {regionOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
              </Col>

              <Col md={2} className="d-flex justify-content-center">
                <Button
                  size="sm"
                  style={{ background: "#441752", color: "#fff" }}
                  onClick={() => DomainRankingKeywords("1")}
                >
                  Analyze
                </Button>
              </Col>
            </Row>

            {showResults && (
              <>
                {" "}
                <Row className="p-0 m-2">
                  <Card
                    className="p-2 m-2 col"
                    style={{
                      background: "#E3F2FD",
                      border: "1px solid #90CAF9",
                    }}
                  >
                    <div className="row p-0 m-0">
                      <div className="col justify-content-center text-center">
                        <h6>Site</h6>
                        <hr className="m-1 p-0" />
                        <h5>{queary?.query}</h5>
                      </div>
                      <div className="col justify-content-center text-center">
                        <h6>Ranking Keyword</h6>
                        <hr className="m-1 p-0" />
                        <h4>{rankingKeywords?.length}</h4>
                      </div>
                    </div>
                  </Card>

                  <Card
                    className="p-2 m-2 col"
                    style={{
                      background: "#FFF3E0",
                      border: "1px solid #FFB74D",
                    }}
                  >
                    <div>
                      <h6>Top Position Keywords</h6>
                      <hr className="m-1 p-0" />
                      <Row className="m-0 p-0">
                        <Col>
                          <p className="mb-0"># 1-3</p>
                        </Col>
                        <Col>
                          <p className="mb-0">{range1to3} Keywords</p>
                        </Col>
                      </Row>
                      <Row className="m-0 p-0">
                        <Col>
                          <p className="mb-0"># 4-10</p>
                        </Col>
                        <Col>
                          <p className="mb-0">{range4to10} Keywords</p>
                        </Col>
                      </Row>
                    </div>
                  </Card>
                </Row>
                <div className="table-container m-3">
                  <table
                    className="table table-bordered w-100 mt-3"
                    style={{
                      backgroundColor: "#F3E5F5",
                      borderBottom: "2px solid #6A1B9A",
                      color: "#4A148C",
                    }}
                  >
                    <thead style={{ backgroundColor: "#CE93D8" }}>
                      <tr>
                        <th>Keyword</th>
                        <th>
                          Domain<h6>{queary?.query}</h6>
                        </th>
                        <th>Difficulty</th>
                        <th>Monthly Volume</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rankingKeywords
                        ?.slice(0, 5)
                        ?.map((keywordData, index) => {
                          const isBlurred = index >= 3;

                          return (
                            <tr
                              key={index}
                              style={{
                                filter: isBlurred ? "blur(4px)" : "none",
                                pointerEvents: isBlurred ? "none" : "auto",
                                transition: "filter 0.3s ease",
                              }}
                            >
                              <td>{keywordData?.keyword}</td>
                              <td>
                                #{keywordData?.rank_position}
                                <br />
                                <p className="mb-0">
                                  {keywordData?.ranking_page}
                                </p>
                              </td>
                              <td>{keywordData?.difficulty}</td>
                              <td>{keywordData?.volume}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan={4} className="text-center">
                          <button
                            onClick={handleClick}
                            style={{
                              marginTop: "10px",
                              padding: "6px 16px",
                              borderRadius: "999px",
                              backgroundColor: "#0d6efd",
                              color: "#fff",
                              border: "none",
                              fontWeight: "600",
                              fontSize: "0.95rem",
                              cursor: "pointer",
                            }}
                          >
                            View Full Report
                          </button>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>{" "}
              </>
            )}
          </Col>
        </Row>
      </div>
    </div>
  );
};
const cardData = [
  {
    title: "Top Pages",
    description:
      "Compare and analyze the performance of your most linked pages and that of your competitors. Learn about high-impact SEO opportunities.",
    linkText: "Top Pages",
    linkUrl: "/top-pages",
    bgColor: "#dff5ff",
  },
  {
    title: "Link Building Tool",
    description:
      "Determine broken or lost backlinks and turn them into new opportunities to establish stronger relations.",
    linkText: "Link Building Tool",
    linkUrl: "/link-building-tool",
    bgColor: "#f4f7fb",
  },
  {
    title: "Domain Authority",
    description:
      "Assess the authority rating and any future search engine of a web site with more than 15 reliable ranking factors and domain measures.",
    linkText: "DA Checker",
    linkUrl: "/da-pa-checker",
    bgColor: "#d6ffd6",
  },
];
const BackLinkCards = () => {
  return (
    <div style={{ overflow: "hidden", padding: "20px" }}>
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">
            Backlink Optimization Toolkit: Everything You Need
          </h2>
        </div>
        <div className="row justify-content-center g-4">
          {cardData.map((card, index) => (
            <div key={index} className="col-md-6 col-lg-3 p-1">
              <div
                style={{
                  backgroundColor: card.bgColor,
                  padding: "24px",
                  borderRadius: "20px",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <h5 className="fw-bold">{card.title}</h5>
                  <p className="text-muted" style={{ fontSize: "15px" }}>
                    {card.description}
                  </p>
                </div>
                <div>
                  <a
                    href={card.linkUrl}
                    className="text-primary fw-semibold"
                    style={{ textDecoration: "none" }}
                  >
                    {card.linkText} →
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Backlinkchecker;
